import Tab, { type TabProps } from "@mui/material/Tab";
import { BodyTextS } from "@repo/ui";
import { Link } from "gatsby-theme-material-ui";
import { type FC } from "react";

export interface LinkTabProps extends TabProps {
	variant?: "desktop";
}

export const LinkTab: FC<LinkTabProps> = ({ sx, label, icon, variant, ...rest }) => {
	return (
		<Tab
			component={Link}
			{...rest}
			sx={{
				...sx,
				width: "25%",
				minWidth: variant === "desktop" ? "100px" : "60px",
				maxWidth: "94px",
				height: variant === "desktop" ? "80px" : "64px",
				minHeight: "0",
				padding: 2,
				textTransform: "none",
			}}
			label={<BodyTextS mb={0}>{label}</BodyTextS>}
			icon={icon}
		/>
	);
};

